var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full-heigth", staticStyle: { padding: "15px" } },
    [
      _vm.isAdmin
        ? _c(
            "el-form",
            { staticClass: "filter-form", attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "agency-select-item",
                  staticStyle: { width: "100%" },
                  attrs: { label: "旅行社" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.isAdmin ? false : true,
                        filterable: "",
                        placeholder: "請選擇旅行社",
                      },
                      model: {
                        value: _vm.agencyCode,
                        callback: function ($$v) {
                          _vm.agencyCode = $$v
                        },
                        expression: "agencyCode",
                      },
                    },
                    _vm._l(_vm.agencyList, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.val, value: item.key },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form",
        {
          staticClass: "filter-form",
          staticStyle: { display: "flex" },
          attrs: { inline: true },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "查詢" } },
            [
              _c("el-input", {
                staticStyle: { width: "280px" },
                attrs: {
                  placeholder: "請輸入旅客名稱/公司名稱/負責業務員",
                  disabled: !_vm.agencyCode,
                },
                model: {
                  value: _vm.listQueryByGroupQuote.search.query,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQueryByGroupQuote.search, "query", $$v)
                  },
                  expression: "listQueryByGroupQuote.search.query",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { margin: "8px 0 0 8px" } },
            [
              _c("el-button", {
                attrs: {
                  type: "primary",
                  icon: "el-icon-search",
                  circle: "",
                  loading: _vm.loading,
                  disabled: !_vm.agencyCode,
                },
                on: { click: _vm.handleSearch },
              }),
              _c("el-button", {
                attrs: {
                  type: "success",
                  icon: "el-icon-refresh-left",
                  circle: "",
                  loading: _vm.loading,
                  disabled: !_vm.agencyCode,
                },
                on: { click: _vm.handleRefresh },
              }),
              _c("el-button", {
                attrs: {
                  type: "warning",
                  icon: "el-icon-plus",
                  circle: "",
                  loading: _vm.loading,
                  disabled: !_vm.agencyCode,
                },
                on: { click: _vm.handleCreate },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                size: "mini",
                data: _vm.listByGroupQuote,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "calc(80vh - 180px)",
                "overflow-x": "auto",
                "row-class-name": _vm.tableRowClassName,
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "旅客填答網址",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleQuestionUrlLink(
                                  scope.row.questionUrl,
                                  $event
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(scope.row.signatureStatusDesc) + " "
                            ),
                            _c("i", { staticClass: "el-icon-copy-document" }),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "出團名稱",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.contentTitle))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "旅客名稱 / 職稱",
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.travelerName) +
                              " " +
                              _vm._s(
                                scope.row.travelerJob
                                  ? " / " + scope.row.travelerJob
                                  : ""
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "公司名稱", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.companyName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "聯絡電話", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.tel))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "E-mail", "min-width": "250" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.email) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "負責業務員",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.saleerName) +
                            " " +
                            _vm._s(
                              scope.row.saleerNickName
                                ? " (" + scope.row.saleerNickName + ")"
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "建立時間", "min-width": "145" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.createTime) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "編輯報價單",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "success",
                              size: "mini",
                              disabled:
                                !scope.row.travelerName ||
                                scope.row.travelerName == "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditQuote(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 編輯 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "發送報價單",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              disabled:
                                !scope.row.travelerName ||
                                scope.row.travelerName == "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleSendQuote(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 發送 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "報價狀態",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !scope.row.status ||
                        scope.row.status == _vm.statusEnum.WaitReply
                          ? _c("div", [_vm._v("等待回覆")])
                          : _vm._e(),
                        scope.row.status == _vm.statusEnum.WaitQuote
                          ? _c("div", [_vm._v("已回覆等待報價")])
                          : _vm._e(),
                        scope.row.status == _vm.statusEnum.WaitReplyByQuoteed
                          ? _c("div", [_vm._v("已報價等待回覆確認")])
                          : _vm._e(),
                        _c(
                          "div",
                          [
                            _c("el-checkbox", {
                              attrs: {
                                label: "旅客確認報價",
                                name: "type",
                                value:
                                  scope.row.status == _vm.statusEnum.Closed,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.handleChangeStatus(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "最後填答時間",
                  "min-width": "250",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" " + _vm._s(scope.row.lastQuestionTime) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "操作", "min-width": "260" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "info", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("客戶資料")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("刪除")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "warning", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCopy(scope.row)
                              },
                            },
                          },
                          [_vm._v("複製")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.listQueryByGroupQuote.total > 0,
                expression: "listQueryByGroupQuote.total > 0",
              },
            ],
            attrs: {
              layout: "prev, pager, next",
              total: _vm.listQueryByGroupQuote.total,
              page: _vm.listQueryByGroupQuote.page,
              limit: _vm.listQueryByGroupQuote.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.listQueryByGroupQuote, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.listQueryByGroupQuote, "limit", $event)
              },
              pagination: _vm.handlePagination,
            },
          }),
        ],
        1
      ),
      _c("group-quote-create-or-update-dialog", {
        attrs: {
          visible: _vm.dialogVisibleByGroupQuote,
          "initial-form-data": _vm.formDataByGroupQuote,
          "agency-code": _vm.agencyCode,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisibleByGroupQuote = $event
          },
          "update:initialFormData": function ($event) {
            _vm.formDataByGroupQuote = $event
          },
          "update:initial-form-data": function ($event) {
            _vm.formDataByGroupQuote = $event
          },
          save: _vm.handleDialogSaveByGroupQuote,
          closed: _vm.handleDialogCloseByGroupQuote,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }